<script setup>
import { ref } from 'vue'
import { ChevronDown, Plane } from 'lucide-vue-next'

const props = defineProps({
  aircraft: { type: Object, required: true },
  // Outras aeronaves do cliente (mock); a atual sempre encabeça a lista.
  options: { type: Array, default: () => [] },
})

const open = ref(false)
const selected = ref(props.aircraft)

const choose = (item) => {
  selected.value = item
  open.value = false
}
</script>

<template>
  <div class="relative w-full max-w-md">
    <button
      type="button"
      class="flex w-full items-center gap-4 rounded-card bg-white px-3 py-3 shadow-card"
      :aria-expanded="open"
      aria-haspopup="listbox"
      @click="open = !open"
    >
      <span class="flex h-11 w-20 shrink-0 items-center justify-center rounded-md bg-slate-100" aria-hidden="true">
        <Plane class="h-6 w-6 -rotate-45 text-up-navy/70" />
      </span>
      <span class="text-lg font-bold tracking-wide text-up-navy">
        {{ selected.registration }} <span class="text-slate-300">•</span> {{ selected.model }}
      </span>
      <ChevronDown class="ml-auto h-5 w-5 text-slate-400 transition-transform" :class="open && 'rotate-180'" aria-hidden="true" />
    </button>

    <ul
      v-if="open"
      class="absolute z-10 mt-2 w-full overflow-hidden rounded-card bg-white py-1 shadow-card"
      role="listbox"
      aria-label="Selecionar aeronave"
    >
      <li v-for="item in [aircraft, ...options]" :key="item.registration">
        <button
          type="button"
          role="option"
          :aria-selected="item.registration === selected.registration"
          class="flex w-full items-center gap-3 px-4 py-3 text-left text-sm hover:bg-up-bg"
          :class="item.registration === selected.registration ? 'font-semibold text-up-navy' : 'text-slate-600'"
          @click="choose(item)"
        >
          <Plane class="h-4 w-4 -rotate-45 text-slate-400" aria-hidden="true" />
          {{ item.registration }} <span class="text-slate-300">•</span> {{ item.model }}
        </button>
      </li>
    </ul>
  </div>
</template>
